export default {
  formFullName: 'Nombre completo',
  salesInquiries: 'Consultas de ventas',
  formEmail: 'Correo electrónico',
  formMobileNumber: 'Número de móvil',
  formAlternatePhoneNumber: 'Número de teléfono alternativo',
  formCustomerType: 'Tipo de cliente',
  formCustomerTypeUSGovernment: 'Gobierno de EE. UU.',
  formCustomerTypeUSMilitary: 'Militar de EE. UU.',
  formCustomerTypeFederalGovernment: 'Gob. Federal',
  formCustomerTypeStateGovernment: 'Gob. Estatal',
  formCustomerTypeCountyGovernment: 'Gob. del Condado',
  formCustomerTypeCityGovernment: 'Gob. Municipal',
  formCustomerTypeSheriffs: 'Sheriffs',
  formCustomerTypeForeignGovernment: 'Gobierno Extranjero',
  formCustomerTypeForeignGovernmentMilitary: 'Sector Militar',
  formCustomerTypeForeignGovernmentNonMilitary: 'Sector No Militar',
  formCustomerTypeBusiness: 'Empresa/Corporativo',
  formCustomerTypePrivateIndividual: 'Privado/Individual',
  formCustomerTypeUSResident: 'Residente de EE. UU.',
  formCustomerTypeNonUSResident: 'No Residente de EE. UU.',
  formCustomerTypeBroker: 'Corredor',
  formCustomerTypeNGO: 'ONG',
  formCustomerTypeOther: 'Otro',
  formInquiry: 'Tu consulta',
  formInquiryPoliceLawEnforcement: 'Policía y Fuerzas del Orden',
  formInquirySWAT: 'Camiones Tácticos SWAT',
  formInquiryTacticalVans: 'Furgonetas Tácticas',
  formInquiryAllOfTheAbove: 'Todas las anteriores',
  formInquiryRiot: 'Control de Disturbios/Cañón de Agua',
  formInquiryRentingSWATTrucks: 'Alquiler de camiones SWAT',
  formInquiryPreviouslyOwned: 'Usado (Segunda Mano)',
  formInquiryParts: 'Piezas y accesorios',
  formInquiryWarranty: 'Relacionado con la Garantía',
  formInquiryDealer: 'Convertirse en Distribuidor',
  formInquiryEmployment: 'Oportunidades de Empleo',
  formInquiryOther: 'Otro',
  formContactVia: 'Prefiero ser contactado a través de',
  formContactViaMobile: 'Móvil',
  formContactViaLandline: 'Línea fija',
  formContactViaEmail: 'Correo electrónico',
  formContactViaText: 'Mensaje de texto',
  formContactViaWhatsapp: 'WhatsApp',
  formHear: '¿Cómo te enteraste de nosotros?',
  formHearSocialMedia: 'Redes Sociales',
  formHearYouTube: 'YouTube',
  formHearInstagram: 'Instagram',
  formHearTikTok: 'TikTok',
  formHearFacebook: 'Facebook',
  formHearTwitter: 'X (Twitter)',
  formHearLinkedIn: 'LinkedIn',
  formHearWeChat: 'WeChat',
  formHearSnapchat: 'Snapchat',
  formHearReddit: 'Reddit',
  formHearSearchEngines: 'Motores de Búsqueda',
  formHearGoogle: 'Google',
  formHearBing: 'Bing',
  formHearYahoo: 'Yahoo',
  formHearDuckDuckGo: 'DuckDuckGo',
  formHearBaidu: 'Baidu',
  formHearAI: 'IA',
  formHearGemini: 'Gemini',
  formHearChatGPT: 'ChatGPT',
  formHearClaude: 'Claude',
  formHearCoPilot: 'CoPilot',
  formHearGrok: 'Grok',
  formHearPerplexity: 'Perplexity',
  formHearMetaAI: 'Meta AI',
  formHearMistral: 'Mistral',
  formHearDeepSeek: 'DeepSeek',
  formHearTradeShow: 'Feria Comercial',
  formHearRepeat: 'Cliente recurrente',
  formHearKnew: 'Ya conozco Alpine Armoring',
  formHearThird: 'Reseña de terceros',
  formHearArmoredVehiclesSite: 'A través del sitio "ArmoredVehicles.com"',
  formHearFriend: 'Amigo',
  formHearReferral: 'Referencia',
  formHearOther: 'Otro',
  formCountry: 'País',
  formState: 'Estado',
  formMessage: 'Mensaje',
  formSendMessage: 'Enviar mensaje',
  formErrorsNameRequired: 'El nombre es obligatorio',
  formErrorsNameValid: 'Por favor, proporcione un nombre válido',
  formErrorsEmailRequired: 'El correo electrónico es obligatorio',
  formErrorsEmailValid: 'Dirección de correo electrónico no válida',
  formErrorsPhoneValid: 'Por favor, ingrese un número de teléfono válido',
  formErrorsMobileRequired: 'El número de móvil es obligatorio',
  formErrorsMobileValid: 'Por favor, ingrese un número de móvil válido',
  formErrorsCountryRequired: 'El país es obligatorio',
  formErrorsStateRequired: 'El estado es obligatorio',
  formSent: '¡Enviado!',
  error: 'Error',
  partsServiceWarranty: 'Piezas, Servicio y<br />Garantía',

  availableNowURL: '/disponible-ahora',
  availableNowSuvsURL: '/disponible-ahora/modelos/suvs-blindados',
  availableNowSedansURL: '/disponible-ahora/modelos/sedanes-blindados',
  availableNowSpecialURL: '/disponible-ahora/modelos/especial-del-mes',
  availableNowTrucksURL: '/disponible-ahora/modelos/camionetas-blindadas',
  availableNowLawURL: '/disponible-ahora/modelos/blindados-fuerzas-del-orden',
  availableNowSpecialtyURL:
    '/disponible-ahora/modelos/vehiculos-blindados-especiales',
  preOwnedURL: '/disponible-ahora/modelos/blindados-pre-usados',
  armoredRentalURL: '/alquiler-blindados',
  rentalsURL: '/disponible-ahora/tipo/alquiler-de-blindados',
  vehiclesWeArmorURL: '/vehiculos-que-blindamos',
  suvsURL: '/vehiculos-que-blindamos/tipo/suvs-blindados',
  sedansURL: '/vehiculos-que-blindamos/tipo/sedanes-blindados',
  specialtyURL: '/vehiculos-que-blindamos/tipo/vehiculos-blindados-especiales',
  pickupTrucksURL: '/vehiculos-que-blindamos/tipo/camionetas-blindadas',
  lawEnforcementURL:
    '/vehiculos-que-blindamos/tipo/blindados-fuerzas-del-orden',
  vansURL: '/vehiculos-que-blindamos/tipo/furgonetas-y-autobuses-blindados',
  citURL: '/vehiculos-que-blindamos/tipo/transporte-blindado-valores-cit',
  aboutURL: '/hacerca-de-nosotros',
  newsURL: '/noticias',
  designEngineeringURL: '/diseno-e-ingenieria',
  manufacturingURL: '/fabricacion',
  shippingLogisticsURL: '/envio-y-logistica',
  mediaURL: '/medios',
  ballisticChartURL: '/tabla-balistica',
  becomeADealerURL: '/conviertase-en-distribuidor',
  ballisticTestingURL: '/pruebas-balisticas',
  faqsURL: '/preguntas-frecuentes',
  locationsWeServeURL: '/ubicaciones-que-servimos',
  contactURL: '/contacto',
  downloadsURL: '/todas-las-descargas',
  privacyPolicyURL: '/politica-de-privacidad',
  vehiclesWeArmorStock: '/disponible-ahora/?vehiculos_que_blindamos=',
  availableNowTitle: 'Disponible ahora',
  vehiclesWeArmor: 'Vehículos que blindamos',
  suvsTitleHeader: 'SUVs',
  sedans: 'Sedanes',
  pickupTrucks: 'Camionetas',
  vansBuses: 'Furgonetas y autobuses',
  lawEnforcement: 'Vehículos para fuerzas del orden',
  CITNavigation: 'Transporte de valores (CIT)',
  specialtyVehicles: 'Vehículos especiales',
  aboutUs: 'Sobre nosotros',
  aboutTitle: 'Sobre Alpine Armoring',
  headerMediaTitle: 'Videos y ferias comerciales',
  designEngineering: 'Diseño e ingeniería',
  manufacturing: 'Fabricación',
  shippingLogistics: 'Envío y logística',
  faq: 'Preguntas frecuentes',
  headerNewsTitle: 'Todas las noticias',
  footerNewsTitle: 'Noticias sobre vehículos blindados',
  ballisticChartTitle: 'Gráfico de Armas y Municiones',
  becomeADealerTitle: 'Conviértase en distribuidor',
  ballisticTestingTitle: 'Pruebas balísticas',
  footerFaqsTitle: 'Preguntas frecuentes',
  locationsWeServeTitle: 'Ubicaciones que servimos',
  footerContactTitle: 'Contacto con Alpine Armoring',
  downloadsTitle: 'Todas las descargas',
  footerAvailableNowTitle: 'Vehículos blindados en venta',
  footerPickupTrucksTitle: 'Camionetas Blindadas',
  footerPreOwnedTitle: 'Vehículos blindados de segunda mano',
  footerLawEnforcementTitle: 'Vehículos Blindados para Servicios Policiales',
  footerSuvsTitle: 'Vehículos Deportivos Utilitarios (SUV) Blindados',
  footerVansTitle: 'Furgonetas y Autobuses Blindados',
  footerSedansTitle: 'Sedanes Blindados',
  footerCitTitle: 'Vehículos Blindados para Transporte de Valores',
  contactUs: 'Contáctenos',
  followUs: 'Síganos en',
  mostPopularServices: 'Todos los Vehículos Blindados que Ofrecemos',
  quickLinks: 'Enlaces rápidos',
  privacyPolicy: 'Política de privacidad',
  allRightsReserved: 'Todos los derechos reservados',
  homeOfArmoredVehicles: 'El hogar de ArmoredVehicles.com',
  inquiringAbout: 'Está consultando sobre',
  thisReadyToShip: 'este listo para enviar',
  rentalOfThis: 'Alquiler de este',
  the: 'el',
  vehicleID: 'ID del vehículo',
  moreInformationForm: 'para más información, complete este formulario',
  productionDistribution: 'Producción y distribución',
  distribution: 'Distribución',
  clientsDealers: 'Clientes y distribuidores',
  contact: 'Contacto',
  countries: 'países',
  states: 'estados',
  majorCities: 'ciudades principales',
  moreFAQ: 'Más preguntas frecuentes',
  locationsWeServe: 'Ubicaciones que servimos',
  armored: 'Blindado',
  forPreorder: 'para pedido anticipado',
  alpineShield: 'Escudo Alpine',
  cookieTitle: 'Valoramos su privacidad',
  cookieText:
    'Utilizamos cookies para mejorar su experiencia de navegación, mostrar anuncios o contenido personalizado y analizar nuestro tráfico. Al hacer clic en "Aceptar todo", acepta nuestro uso de cookies.',
  acceptAll: 'Aceptar todo',
  rejectAll: 'Rechazar todo',
  noOneProtectsBetter: 'nadie te protege mejor',
  seeAllNews: 'Ver todas las noticias',
  searchPlaceholder: 'Buscar...',
  noResultsFound: '¡No se encontraron resultados!',
  shareCopyLink: 'Copiar enlace',
  shareCopied: '¡Copiado!',
  shareCopyFailed: '¡Falló la copia!',
  shareEmailSubject: 'Mira este artículo',
  shareEmailBody: 'Pensé que podría interesarte',
  readMore: 'Leer más',
  readyToRent: 'Listo para alquilar',
  specialOfTheMonthButton: '¡Consulte nuestras ofertas limitadas!',
  categoriesMainButton: 'Disponible ahora / Listo para enviar',
  weArmor: 'nosotros blindamos',
  allArmoredVehicles: 'Todos los vehículos blindados',
  industryPartners: 'Socios de la industria',
  videoTagNotSupported: 'Su navegador no soporta la etiqueta de video.',
  select: 'Seleccionar',
  all: 'Todo',
  clearAllFilters: 'Borrar todos los filtros',
  filters: 'Filtros',
  search: 'Buscar',
  viewDetails: 'Ver detalles',
  armoredTo: 'Blindado a',
  level: 'nivel',
  engine: 'Motor',
  trans: 'Transmisión',
  VIN: 'VIN',
  requestAQuote: 'Solicitar presupuesto',
  viewInStockAvailability: 'Ver disponibilidad en stock',
  watch: 'Ver',
  video: 'Video',
  offeredAtProtectionLevels: 'Ofrecido en niveles de protección',
  hpLatestNews: 'Industria de blindaje',
  blogsURL: '/blog',
  blogsTitle: 'Blogs y Perspectivas',

  ballisticTests: 'Pruebas Balísticas',
  mediaAppearances: 'Apariciones en Medios de comunicacion',
  coolVideos: 'Videos Geniales',
  selectedVansAndTrucks: 'Furgonetas y Camiones Seleccionados',
  selectedSUVsAndSedans: 'SUVs y Sedanes Seleccionados',
  armoredRental: 'Alquiler de autos blindados',
  type: 'tipo',
  exploreDifferentModels: 'Explora diferentes modelos de',
};
